import { Link } from 'react-router-dom';

/** Marca tipografica "CABAL / LIBERTY" (Cinzel) — usada no header, footer, cadastro e painel. */
export function Brand({ to = '/', className = '', onClick }: { to?: string; className?: string; onClick?: () => void }) {
  return (
    <Link className={`brand ${className}`.trim()} to={to} onClick={onClick}>
      <span>CABAL</span><b>LIBERTY</b>
    </Link>
  );
}
